"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencySelectorOptions = exports.CurrencySelectorToggle = exports.CurrencySelectorButton = exports.CurrencySelector = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Compensation = require("../Compensation");

var _style = require("./style");

var _motion = require("../../../style/motion");

var CurrencySelector = _styledComponents["default"].div.withConfig({
  displayName: "CurrencySelector",
  componentId: "x41kwr-0"
})(["", " ", " --spacingY:9px;position:relative;padding:0;width:auto;font-size:1.25rem;line-height:1.25em;", " &{border-left-width:0;}"], _style.InputStyle, _Compensation.CompensationInputStyle, _Compensation.CompensationInput);

exports.CurrencySelector = CurrencySelector;

var CurrencySelectorButton = _styledComponents["default"].button.withConfig({
  displayName: "CurrencySelector__CurrencySelectorButton",
  componentId: "x41kwr-1"
})(["", " display:flex;align-items:center;font-size:inherit;font-family:inherit;line-height:inherit;color:inherit;background-color:var(--inputBackground);border:none;padding:var(--spacingY) var(--spacingX);& + &{border-top:var(--inputBorderSize) solid var(--inputBorderColor);}&:hover,&:focus{background-color:var(--inputBackgroundActive);outline:none;}"], (0, _motion.sharedTransition)('background-color'));

exports.CurrencySelectorButton = CurrencySelectorButton;

var CurrencySelectorToggle = _styledComponents["default"].div.withConfig({
  displayName: "CurrencySelector__CurrencySelectorToggle",
  componentId: "x41kwr-2"
})(["", " margin-left:10px;transform:rotate(", ");svg{display:block;}"], (0, _motion.sharedTransition)('transform'), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? '180deg' : '0deg';
});

exports.CurrencySelectorToggle = CurrencySelectorToggle;

var CurrencySelectorOptions = _styledComponents["default"].div.withConfig({
  displayName: "CurrencySelector__CurrencySelectorOptions",
  componentId: "x41kwr-3"
})(["position:absolute;left:0;top:100%;margin-top:var(--inputBorderSize);right:0;display:flex;flex-direction:column;border-width:var(--inputBorderSize);border-top-width:0;border-style:solid;border-color:var(--inputBorderColor);margin-left:calc(var(--inputBorderSize) * -1);margin-right:calc(var(--inputBorderSize) * -1);"]);

exports.CurrencySelectorOptions = CurrencySelectorOptions;